import { render, staticRenderFns } from "./ComponentCreateForm.vue?vue&type=template&id=3080f131"
import script from "./ComponentCreateForm.vue?vue&type=script&lang=js"
export * from "./ComponentCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports